import { Outlet, useOutletContext } from 'react-router';

export const useLayoutData = () => {
  return useOutletContext();
};

const ClubLayout = () => {
  return <Outlet />;
};

export default ClubLayout;
